<template>
  <div class="order">
    <p class="title">我的订单</p>
    <el-table
      :data="tableData"
      style="width: 98%"
      :header-cell-style="{ background: '#f4f4f4', color: '#666' }"
    >
      <el-table-column prop="order_sn" label="订单号"></el-table-column>
      <el-table-column prop="title" label="订单类型"></el-table-column>
      <el-table-column prop="pay_money" label="实付款" width="100">
        <template slot-scope="scope">￥{{ scope.row.pay_money }}</template>
      </el-table-column>
      <el-table-column
        prop="createtime"
        label="下单时间"
        width="180"
      ></el-table-column>
      <el-table-column prop="pay_time" label="支付时间" width="180">
        <template slot-scope="scope">
          <p v-if="scope.row.pay_time">{{ scope.row.pay_time }}</p>
          <p v-else>--</p>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="订单状态">
        <template slot-scope="scope">
          <p v-show="scope.row.status == 0" class="status1">
            <span></span>等待支付
          </p>
          <p v-show="scope.row.status == 2" class="status2">
            <span></span>已取消
          </p>
          <p v-show="scope.row.status == 1" class="status3">
            <span></span>已支付
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="支付方式" width="120">
        <template slot-scope="scope">
          <p v-if="scope.row.pay_type_text">{{ scope.row.pay_type_text }}</p>
          <p v-else>--</p>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="120">
        <template slot-scope="scope">
          <p
            v-if="scope.row.status == 0"
            style="color: #2d8af5; cursor: pointer"
            @click="payPay(scope.row.id)"
          >
            去支付
          </p>
          <p v-else>--</p>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        @current-change="handleSizeChange"
      >
      </el-pagination>
    </div>
    <el-dialog title="支付订单" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <img :src="code_url" alt="" class="payimg"/>
    </el-dialog>
  </div>
</template>

<script>
import { orderGetList,payPay,orderQuery } from "@/api/user";
export default {
  data() {
    return {
      time: "",
      dialogVisible: false,
      tableData: [],
      page: 1,
      total: 20,
      code_url: "",
    };
  },
  mounted() {
    this.orderGetList();
  },
  methods: {
    handleClose(done) {
      clearInterval(this.time);
      done();
    },
    handleSizeChange(val) {
      this.page = val;
      this.orderGetList();
    },
    orderGetList() {
      orderGetList({ page: this.page }).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
      });
    },
    payPay(id) {
      clearInterval(this.time);
      this.dialogVisible = true;
      let pay = {
        id: id,
        pay_type: "scan",
      };
      payPay(pay).then((res) => {
        this.code_url = res.data.code_url;
        this.time = setInterval(() => {
          orderQuery({ id: id }).then((res) => {
            if (res.data.status == 1) {
              this.$message({
                message: "支付成功",
                type: "success",
              });
              location.reload();
            }
          });
        }, 2000);
      });
    },
  },
};
</script>

<style lang="less">
.payimg{
  width: 100%;
}

.order {
  width: 100%;
  padding: 0 32px;
  .title {
    font-size: 20px;
    font-weight: 700;
    display: flex;
    align-items: center;
    span {
      width: 155px;
      height: 45px;
      background: linear-gradient(
        94.94deg,
        #e4e8ff 0.7%,
        #f7f5ff 44.6%,
        #fef1ff 100%
      );
      border-radius: 22.5px;
      font-weight: 700;
      font-size: 16px;
      line-height: 21px;
      color: #4e5969;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 16px;
    }
  }
  .pagination {
    text-align: center;
  }
  .status1 {
    span {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #2d8af5;
      margin-right: 6px;
    }
  }
  .status2 {
    span {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #ddd;
      margin-right: 6px;
    }
  }
  .status3 {
    span {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #67c23a;
      margin-right: 6px;
    }
  }
}
</style>